import { jsx as n } from "react/jsx-runtime";
import * as i from "react";
import { c as u } from "./index-DLeNytVF.js";
import { u as g } from "./index-DYfkNB0n.js";
import { P as p } from "./index-BrTLHETv.js";
import { $ as v } from "./utils-CTvPli9r.js";
import { c as b } from "./index-CYpVUGdk.js";
var d = "Toggle", l = i.forwardRef((e, t) => {
  const { pressed: a, defaultPressed: o, onPressedChange: r, ...m } = e, [s, c] = g({
    prop: a,
    onChange: r,
    defaultProp: o ?? !1,
    caller: d
  });
  return /* @__PURE__ */ n(
    p.button,
    {
      type: "button",
      "aria-pressed": s,
      "data-state": s ? "on" : "off",
      "data-disabled": e.disabled ? "" : void 0,
      ...m,
      ref: t,
      onClick: u(e.onClick, () => {
        e.disabled || c(!s);
      })
    }
  );
});
l.displayName = d;
var f = l;
const h = b(
  "inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium transition-colors hover:bg-muted hover:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-accent data-[state=on]:text-accent-foreground [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-transparent",
        outline: "border border-input bg-transparent shadow-sm hover:bg-accent hover:text-accent-foreground"
      },
      size: {
        default: "h-9 px-2 min-w-9",
        sm: "h-8 px-1.5 min-w-8",
        lg: "h-10 px-2.5 min-w-10"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), x = i.forwardRef(({ className: e, variant: t, size: a, ...o }, r) => /* @__PURE__ */ n(f, { ref: r, className: v(h({ variant: t, size: a, className: e })), ...o }));
x.displayName = f.displayName;
export {
  x as T,
  h as t
};
//# sourceMappingURL=toggle-BswawoKY.js.map
